import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    Fancybox.bind('[paws-component="noss-hero"][paws-template="buttons"] .nfoimg');
}
